import request from '../request';
import { CustomerTypeAPI } from './urls';

export const getAllActiveCustomerTypes = () => {
  return request({
    url: CustomerTypeAPI.getAllActive,
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

export const getAllCustomerTypes = () => {
  return request({
    url: CustomerTypeAPI.getAll,
    method: 'GET',
  })
    .then((response) => response)
    .catch((error) => error);
};

const customerTypeService = {
  getAllActiveCustomerTypes,
  getAllCustomerTypes,
};

export default customerTypeService;
